import useAPI from "./useAPI";
import useCompany from "./useCompany";

export default function useMultimedia() {
    const { activeCompany: company } = useCompany();
    const api = useAPI();

    async function upload(file) {
        if (!file) throw new Error("No file provided");

        const companyId = company?.id;
        if (!companyId) throw new Error("Missing company id");

        const { url, fileUrl } = await api.uploadMultimedia(companyId, file);

        return url || fileUrl;
    }

    const handleImageChange = (event, setState) => {
        const file = event.target.files[0]
        if (file && file.type.startsWith("image/")) {
            setState(file)
        } else {
            throw new Error("Please select a valid image file.")
        }
    }

    return {
        upload,
        handleImageChange
    }
}